<template>
  <div
    class="switch-profile-wrapper"
    :class="{
      'is-variant-header': currentVariantHeader,
    }"
    @focusout="sendBlurEvent"
  >
    <div class="upper-area-wrapper">
      <div class="photo-wrapper">
        <img :src="imgSrc" alt="profile image" class="photo" />
      </div>
      <div class="user-info-wrapper">
        <h3 class="name">
          {{ name }}
        </h3>
        <div class="subinfo">
          <span :title="position" v-if="position">{{ position }}</span
          ><span v-if="position && firstNodeName"> / </span
          ><span :title="nodeNames" v-if="firstNodeName">{{ firstNodeName }}</span>
        </div>
        <div class="email">
          {{ email }}
        </div>
      </div>
    </div>
    <div class="lower-area-wrapper">
      <ul class="menu-link-wrapper">
        <li>
          <a :href="links['setting']" class="menu-link">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#909090"
                aria-hidden="true"
              >
                <path
                  d="M-210.687-393a1.31 1.31 0 0 1-1.313-1.312v-1.138a3.675 3.675 0 0 1 3.676-3.675c.787 0 1.164.437 2.45.437s1.662-.437 2.45-.437a3.675 3.675 0 0 1 3.676 3.675v1.138a1.31 1.31 0 0 1-1.315 1.312Zm-.312-2.45v1.138a.31.31 0 0 0 .312.312h9.625a.31.31 0 0 0 .312-.312v-1.138a2.68 2.68 0 0 0-2.675-2.675 2 2 0 0 0-.609.132 5.6 5.6 0 0 1-1.84.305 5.6 5.6 0 0 1-1.84-.305 2 2 0 0 0-.609-.132A2.68 2.68 0 0 0-211-395.45Zm1.624-8.05a3.5 3.5 0 0 1 3.5-3.5 3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5 3.5 3.5 0 0 1-3.5-3.5Zm1 0a2.5 2.5 0 0 0 2.5 2.5 2.5 2.5 0 0 0 2.5-2.5 2.5 2.5 0 0 0-2.5-2.5 2.5 2.5 0 0 0-2.5 2.5Z"
                  style="stroke:transparent;stroke-miterlimit:10"
                  transform="translate(214 408)"
                />
                <path d="M0 0h16v16H0z" style="fill:none" />
              </svg>
            </div>
            <div>
              {{ $t('사용자 설정') }}
            </div>
          </a>
        </li>
        <li>
          <a :href="linkPrefix + links['security']" class="menu-link">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#909090"
                aria-hidden="true"
              >
                <path d="M0 0h16v16H0z" style="fill:transparent" />
                <path
                  d="M13 6h-1V5a4 4 0 0 0-8 0v1H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1M5 5a3 3 0 0 1 6 0v1H5Zm8 9H3V7h10Z"
                />
                <path d="M7.5 10.361V12.5h1v-2.139a1 1 0 1 0-1 0" />
              </svg>
            </div>
            <div>
              {{ $t('보안 설정') }}
            </div>
          </a>
        </li>
        <li class="account-convert" v-if="multiOfficeAccounts.length">
          <div>
            <h4>{{ $t('계정 전환') }}</h4>
            <ul class="account-convert-list-wrapper">
              <li
                class="account-convert-item"
                v-for="account in multiOfficeAccounts"
                :key="account.user_no"
                @click="() => handleSwitchAccount(account)"
              >
                <img
                  :src="`${account.profile_image_path}?filter[office_no]=${account.office_no}`"
                  alt="profile image"
                  class="sub-photo"
                />
                <div class="account-convert-sub-info">
                  <div class="name-wrapper">
                    <span class="name">{{ account.user_name }}</span>
                    <div class="bedge" v-if="!account.is_authorized">{{ $t('인증대기') }}</div>
                  </div>
                  <div>
                    <span class="node">
                      {{ account.office_name }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <a :href="linkPrefix + links['logout']" class="menu-link">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="#909090"
                aria-hidden="true"
              >
                <path
                  d="M-771-873a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1.5h-1v-1.5h-6v12h6v-1.5h1v1.5a1 1 0 0 1-1 1Zm7.294-4.707 1.793-1.793H-769v-1h7.087l-1.793-1.794.706-.706 3 3-3 3Z"
                  style="stroke:transparent;stroke-miterlimit:10"
                  transform="translate(774 888)"
                />
                <path d="M0 0h16v16H0z" style="fill:none" />
              </svg>
            </div>
            <div>
              {{ $t('LOGOUT') }}
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import accountApi from '../../api/account-api';

export default {
  name: 'SwitchProfile',
  props: {
    currentVariantHeader: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      links: {
        security: `/mypage/manager/mysecurity`,
        setting: `${process.env.VUE_APP_OFFICE_MYPAGE_URL}/mypage/manager/myinfo`,
        logout: `/home/logout`,
      },
    };
  },
  methods: {
    sendBlurEvent(e) {
      this.$emit('blur', e);
    },
    /**
     * 인증, 미인증 계정 구분 없이 계정 전환 API를 요청한다.
     * 응답을 가지고 후처리 해준다.(후처리 -> 미인증이면 로그인 페이지로 이동 처리)
     * @param account
     */
    async handleSwitchAccount(account) {
      const loginPath = `${process.env.VUE_APP_OFFICE_LOGIN_URL}/${account.domain}?userId=${account.user_id}`;

      try {
        const response = await accountApi.switchMultiAccount(account.user_no);

        const isNotAuthorized = 202;
        const key = response.data.errors?.[0]?.title;

        if (response.status === isNotAuthorized) {
          if (key === 'REQUIRE_PASSWORD_CHANGE') {
            const cause = response.data.errors?.[0]?.values?.cause;

            if (cause === 'REQUIRE_BY_POLICY') {
              alert(this.$t('비밀번호 유효 기간이 만료되었습니다. 비밀번호 변경 후 이용해 주세요.'));
            } else if (
              cause === 'REQUIRE_BY_ADMIN' ||
              cause === 'ACCOUNT_HIJACKING' ||
              cause === 'SERVICE_DISAGREEMENT'
            ) {
              alert(this.$t('관리자에 의해 비밀번호가 변경되었습니다. 비밀번호 변경 후 이용해 주세요.'));
            } else {
              // 여기는 흐름 상 흐르지 말아야하는 곳이나 혹시나 남겨 둠
              alert(this.$t('일시적인 문제가 발생했습니다. 다시 시도해 주세요.'));
            }

            location.href = loginPath;
            return;
          }

          if (key === 'NOT_AUTHENTICATED_MULTI_POSITION_ACCOUNT') {
            alert(this.$t('계정 전환 기능은 아이디와 비밀번호를 입력하여 최초 1회 인증 후 사용할 수 있습니다.'));
          }

          location.href = loginPath + `&needInitialAuth=Y`;

          return;
        }

        location.href = process.env.VUE_APP_OFFICE_HOME_URL;
      } catch (error) {
        console.error(error);

        const key = error.response.data.errors?.[0]?.title;

        if (key === 'OFFICE_EXPIRED') {
          alert(this.$t('서비스 기간이 만료되었습니다.'));
          return;
        }

        if (key === 'OFFICE_USER_INACTIVE') {
          alert(this.$t('일시 정지 중인 사용자입니다.'));
          return;
        }

        // 다음은 기획에서 공통으로 처리하는걸로 보아 대응하지 않고 나중을 위해 주석 처리
        // if (key === 'ACCOUNT_NOT_FOUND') {
        // }
        //
        // if (key === 'INVALID_MULTI_POSITION_ACCOUNT') {
        //   return;
        // }
        //
        // if (key === 'OFFICE_USER_NOT_REGIST') {
        // }

        // 그 외
        if (error.response.data?.errors?.[0]?.message && typeof error.response.data.errors?.[0]?.message === 'string') {
          alert(error.response.data.errors?.[0]?.message);
          return;
        }

        alert(this.$t('일시적인 문제가 발생했습니다. 다시 시도해 주세요.'));
      }
    },
  },
  computed: {
    ...mapState({
      cacheOfficeInfo: (state) => state.cache.officeInfo,
      cacheUserInfo: (state) => state.cache.userInfo,
      multiOfficeAccounts: (state) => state.multiOffice.multiOfficeAccounts,
    }),

    imgSrc() {
      // @Todo office.hiworks.com에 종속적이라 추후 window의 PATH_INFO참조 무조건 제거
      let domain = null;
      if (window.PATH_INFO && window.PATH_INFO.DOMAIN) {
        if (window.PATH_INFO.URLTYPE === 'G') {
          domain = window.PATH_INFO.GROUPID;
        } else {
          domain = window.PATH_INFO.DOMAIN;
        }
      } else {
        domain = this.cacheOfficeInfo.office.office_id;
      }

      return process.env.VUE_APP_OFFICE_URL + '/' + domain + '/common/profile/me';
    },

    linkPrefix() {
      return `${process.env.VUE_APP_OFFICE_URL}/${this.cacheOfficeInfo.office.office_id}`;
    },

    email() {
      if (this.cacheUserInfo.office && this.cacheOfficeInfo.office.office_type === 'group') {
        return this.cacheUserInfo.user_id;
      }

      if (this.cacheUserInfo.office) {
        return this.cacheUserInfo.user_id + '@' + this.cacheUserInfo.office.office_id;
      }

      return '';
    },

    name() {
      return this.cacheUserInfo?.name || '';
    },

    nodeNames() {
      return this.cacheUserInfo.nodes.map((v) => v.name).join(', ');
    },

    firstNodeName() {
      return this.cacheUserInfo.nodes[0]?.name || '';
    },

    position() {
      return this.cacheUserInfo?.position || '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/base/variables';

.switch-profile-wrapper {
  position: fixed;
  width: 100%;
  right: 0;
  top: $headerHeight;
  background-color: #fff;
  border: solid 1px #909090;
  border-radius: 4px;
  box-shadow: 2px 5px 4px 0px rgba(0, 0, 0, 0.16);

  @media (min-width: 900px) {
    position: absolute;
    width: 280px;
    top: 48px;
  }

  &.is-variant-header {
    top: $managementHeaderHeight;

    @media (min-width: 900px) {
      top: 43px;
    }
  }

  .upper-area-wrapper {
    display: flex;
    position: relative;
    margin: 20px 12px 0;
    gap: 12px;
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    padding: 0 10px 20px;

    .photo-wrapper {
      flex-shrink: 0;

      .photo {
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }

    .user-info-wrapper {
      display: flex;
      flex-direction: column;
      color: #333;
      width: 100%;
      overflow: hidden;

      h3 {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .subinfo {
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .email {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
      }
    }
  }

  .lower-area-wrapper {
    margin-bottom: 12px;
    padding-top: 12px;

    .menu-link-wrapper {
      li {
        .menu-link {
          display: flex;
          align-items: center;
          gap: 10px;
          height: 38px;
          color: #333;
          font-size: 14px;
          padding: 0 21px;

          &:hover {
            background-color: #eff4fc;
          }

          div {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        &.account-convert {
          width: calc(100% - 24px);
          background-color: #eff4fc;
          border-radius: 4px;
          padding: 12px 0;
          margin: 12px auto;

          h4 {
            font-size: 10px;
            color: #676767;
            margin-bottom: 6px;
            padding: 0 16px;
          }

          .account-convert-list-wrapper {
            .account-convert-item {
              display: flex;
              align-items: center;
              color: #333;
              gap: 8px;
              height: 54px;
              padding: 0 16px;
              cursor: pointer;
              overflow: hidden;

              &:hover {
                background-color: #f7faff;
              }

              .sub-photo {
                width: 30px;
                height: 30px;
                border-radius: 100%;
              }

              .account-convert-sub-info {
                overflow: hidden;

                & > div {
                  display: flex;
                  align-items: center;
                }

                .name-wrapper {
                  .name {
                    font-size: 13px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  .bedge {
                    height: 16px;
                    border-radius: 40px;
                    background-color: #676767;
                    color: #fff;
                    font-size: 10px;
                    padding: 0 6px;
                    margin-left: 8px;
                    white-space: nowrap;
                  }
                }

                .node {
                  font-size: 12px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
